// extracted by mini-css-extract-plugin
module.exports = {"navBarRightSide":"NavBar_navBarRightSide__29aDA","cartAndTotal":"NavBar_cartAndTotal__2sx6g","cartTotal":"NavBar_cartTotal__m3Tbv","navBarCentre":"NavBar_navBarCentre__TuPd3"};